import { render } from "./PortfolioNavigation.vue?vue&type=template&id=6e3e0e39&scoped=true"
import script from "./PortfolioNavigation.vue?vue&type=script&lang=ts"
export * from "./PortfolioNavigation.vue?vue&type=script&lang=ts"

import "./PortfolioNavigation.vue?vue&type=style&index=0&id=6e3e0e39&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-6e3e0e39"

export default script